
// You can write more code here

/* START OF COMPILED CODE */

import Powerup from "../../game/powerups/Powerup";
/* START-USER-IMPORTS */
import {LevelManager} from "../../game/LevelManager";
import Tile from "../../game/Tile";
import { Sounds } from "../../sounds";
/* END-USER-IMPORTS */

export default class MarvinMartianPowerup extends Powerup {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // beam-target
    const beam_target = scene.add.image(0, -78, "game-tiles", "marvin-ufo-beam.png");
    beam_target.setOrigin(0.5, 0);
    this.add(beam_target);

    // marvin_ufo
    const marvin_ufo = scene.add.image(-6, 5, "game-tiles", "marvin-ufo.png");
    marvin_ufo.setOrigin(0.5, 1);
    this.add(marvin_ufo);

    this.beam_target = beam_target;
    this.marvin_ufo = marvin_ufo;

    /* START-USER-CTR-CODE */
    this.marvin_ufo.x = 1920 + this.marvin_ufo.width;
    this.marvin_ufo.y = this.scene.cameras.main.height/2;
    this.beam_target.visible = false;
    /* END-USER-CTR-CODE */
  }

  private beam_target: Phaser.GameObjects.Image;
  private marvin_ufo: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  public sizeOfDestroyArea:number = 160;
  private firableItems:{sprite:Phaser.GameObjects.Sprite,dirX:number, dirY:number}[] = [];
  private targetX:number = 0;
  private targetY:number = 0;
  private targetTileX:number = 0;
  private targetTileY:number = 0;

  update(playerX: number, playerY: number, time: number, deltaTime: number) {
    this.playerX = playerX;
    this.playerY = playerY;
  }

  ApplyPowerup(levelManager: LevelManager) {
    super.ApplyPowerup(levelManager);
    //tween on UFO to random position

    this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.MarvinMartian, Sounds.Channel.SFX, {
      volume: 1
    });

    let tile:Tile = this.levelManager.randomTile();

    this.targetX = tile.x;
    this.targetY = tile.y;
    this.targetTileX = tile.x;
    this.targetTileY = tile.y;
    this.targetY = Math.max(tile.y,70);

    this.beam_target.x = this.targetX;
    this.beam_target.y = this.targetY-78;

    let tween = this.scene.tweens.chain({
      targets: this.marvin_ufo,
      tweens: [{
          x:this.targetX,
          y:this.targetY-5,
          ease:'Quad.inOut',
          duration:1000
        }
    ]});

    tween.on('complete', ()=>{
      this.destroyItems();
    });

    //zap a load of items
    //tween off
    //end powerup
  }

  destroyItems()
  {
    this.beam_target.visible = true;
    this.beam_target.scaleY = 0;
    this.beam_target.alpha = 0;

    console.log(this.beam_target.scaleX, this.beam_target.scaleY, this.beam_target.alpha);


    let beamTween = this.scene.add.tween({
      targets: this.beam_target,
      scaleY:1,
      alpha:1,
      duration:200,
      ease: 'Quad.inOut'
    });
    beamTween.on('complete', ()=>{
      this.levelManager.hitObjects(this.targetTileX,this.targetTileY,this.sizeOfDestroyArea/2);
      console.log(this.beam_target.scaleX, this.beam_target.scaleY);
    });

    let tween = this.scene.tweens.chain({

      tweens: [
        {
          targets: this.beam_target,
          scaleY:{value:0,duration:200},
          alpha:{value:0,duration:200},
          delay:500,
          ease: 'Quad.inOut'
        },
        {
          targets: this.marvin_ufo,
          x:-this.marvin_ufo.width,
          ease:'Quad.inOut',
          duration:1000
        }
      ]});

    tween.on('complete', ()=>{
      this.EndPowerup();
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
